<template>
  <div class="games">
    <div id="head-page" class="globulo parallaxe">
      <div ref="scene" id="scene">
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </div>
    </div>

    <div class="grid-container content-page edit">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-10 medium-offset-1 large-8 large-offset-0 cell">
          <bouton href="dashboard" class-bt="return">Retour au carnet de bord</bouton>
          <title-page attrpage="La communauté" baseline="">Gérez les proches & amis de {{ childName }}</title-page>
          <p>Cette page vous permet de gérer les comptes des proches (famille & amis) en lien avec {{ childName }} et qui pourront le/la soutenir durant son chemin vers la guérison.</p>
        </div>
        <div class="small-12 medium-10 medium-offset-1 large-6 large-offset-0 cell">

          <h2>Les proches de {{ childName }}</h2>

          <p v-if="relatives.length === 0">{{ childName }} <strong>n'a aucun proche dans sa communauté</strong> actuellement, </br>pensez à ajouter un ami ou une personne de la famille pour le/la soutenir.</p>

          <bouton href="signupsub">Ajouter un proche pour {{ childName }}</bouton>

          <hr>
          <p>Vous pouvez aussi suggérer à un proche de se créer un compte Globulo Quest relié à celui de {{ childName }} en renseignant son email ici. Une notification lui sera envoyée pour qu’il puisse s’inscrire et suivre le profil de {{ childName }}.</p>


          <div class="formulaire soignant">
            <form ref="form">
              <input type="email" name="email" id="email" v-model="email" required />
              <input class="button btnPush" name="submit" type="submit" value="Envoyer une demande" @click="send"/>
            </form>
          </div>

          <hr>
          <template v-if="relatives.length !== 0">
              <div class="list-relatives">
                <item-sub v-for="relative in relatives" :user="relative" />
              </div>
          </template>

        </div>
        <div class="small-12 medium-10 large-6 medium-offset-1 large-6 large-offset-0 cell">
          <h2>Les amis de {{ childName }}</h2>
          <p v-if="friends.length === 0">{{ childName }} <strong>n'a aucun·e ami·e dans sa communauté</strong> actuellement, </br>pensez à ajouter un·e ami·e pour que {{ childName }} puisse discuter avec.</p>

          <div class="formulaire soignant">
            <form ref="form">
              <input type="email" name="email" id="email" v-model="friendUsername" required />
              <input class="button btnPush" name="submit" type="submit" value="Envoyer une demande"
              @click="sendForFriend"/>
            </form>
          </div>
          <hr>
          <template v-if="friends.length + invitedFriends.length !== 0">
              <div class="list-relatives">
                <item-friend v-for="friend in friends" :user="friend" />
                <item-friend v-for="friend in invitedFriends" :user="friend" :invited="true"/>
              </div>
          </template>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import ItemSub from '@/components/ItemProche'
  import ItemFriend from '@/components/ItemFriend'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: { TitlePage, Bouton, ItemSub, ItemFriend },
    data() {
      return {
        email: '',
        friendUsername: ''
      }
    },
    mounted () {
      var scene = this.$refs.scene;
      var parallaxInstance = new Parallax(scene, {
        scalarY: 3
      });
    },
    computed: {
      ...mapGetters(['childName']),
      relatives() {
        return this.$store.state.subaccounts.relatives
      },
      friends() {
        return this.$store.state.subaccounts.friends
      },
      invitedFriends() {
        return this.$store.state.subaccounts.invitedFriends
      }
    },
    methods: {
      ...mapActions(['sendInvitation', 'addNotice']),
      async send (e) {
        e.preventDefault();

        try {
          this.sendInvitation({ identifier: this.email, role: 'relative' })
          this.addNotice({ message: `L'invitation a été envoyée avec succès.` })
          this.$router.push({name: 'dashboard'})
        } catch (ex) {
          console.log(ex)
        }
      },
      async sendForFriend (e) {
        e.preventDefault();

        try {
          this.sendInvitation({ identifier: this.friendUsername, role: 'friend' })
          this.addNotice({ message: `L'invitation a été envoyée avec succès.` })
          this.$router.push({name: 'dashboard'})
        } catch (ex) {
          console.log(ex)
        }
      }
    }
  }
</script>
